import React from 'react';
import PropTypes from 'prop-types';
import {
  dlsBrightBlue,
  GlyphInfo,
  Tooltip,
  TooltipButton,
} from '@americanexpress/dls-react';

const FxToolTipInfo = ({
 id, content, placement, theme,
}) => (
  <Tooltip
    id={`${id}-tooltip`}
    theme={theme}
    triggerElement={
      <TooltipButton info={true} icon={<GlyphInfo theme={dlsBrightBlue} />} />
      }
    placement={placement}
    info={true}
  >
    {content}
  </Tooltip>
);

FxToolTipInfo.defaultProps = {
  id: 'tooltip',
  placement: 'top',
  theme: null,
};

FxToolTipInfo.propTypes = {
  id: PropTypes.string,
  content: PropTypes.string.isRequired,
  placement: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default FxToolTipInfo;
